module.exports = __webpack_public_path__ + "assets/img/lock.b94e32b0.svg";